const ACCOUNT_DETAILS = "ACCOUNT_DETAILS";
const ACCOUNT_DETAILS_SUCCESS = "ACCOUNT_DETAILS_SUCCESS";
const ACCOUNT_DETAILS_FAILURE = "ACCOUNT_DETAILS_FAILURE";
const CLEAR_ACCOUNT_DETAILS = "CLEAR_ACCOUNT_DETAILS";

const AccountDetailsSymbols = {
  ACCOUNT_DETAILS_SUCCESS,
  ACCOUNT_DETAILS_FAILURE,
  ACCOUNT_DETAILS,
  CLEAR_ACCOUNT_DETAILS,
};
export default AccountDetailsSymbols;
